import { Typography, Form, Table, Divider } from 'antd';
import { checklistPortoComplementaryItems } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.PortoComplementaryItemsConstant';
import {
  ChecklistComplementItemFields,
  ChecklistComplementItemResponse,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import complementItemsColumns from '../complementItemsColumns';

export default function PortoComplementItems() {
  const form = Form.useFormInstance();

  return (
    <>
      {checklistPortoComplementaryItems.map((category) => {
        const complementItems = category.items;

        const items = Form.useWatch<ChecklistComplementItemFields[]>(
          category.key,
          form,
        );

        function handleAllCheckbox(
          checked: boolean,
          responseType: ChecklistComplementItemResponse,
        ) {
          form.setFieldValue(
            category.key,
            complementItems.map((item) => ({
              response: checked ? [responseType] : [],
              description: item.value,
            })),
          );
        }

        function handleAllSelected(
          responseType: ChecklistComplementItemResponse,
        ) {
          return (
            items?.length > 0 &&
            !!items?.every((item) =>
              item.response?.some((type) => type === responseType),
            )
          );
        }

        function handleAllIndeterminate(
          responseType: ChecklistComplementItemResponse,
        ) {
          return (
            items?.length > 0 &&
            !!items?.some((item) =>
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              item.response?.some((type: any) => type === responseType),
            ) &&
            !items?.every((item) =>
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              item.response?.some((type: any) => type === responseType),
            )
          );
        }

        return (
          <div key={category.key}>
            <Typography.Title level={4} style={{ margin: 0 }}>
              {category.label}
            </Typography.Title>

            <Form.List name={category.key}>
              {() => (
                <Table
                  pagination={false}
                  dataSource={category.items}
                  columns={complementItemsColumns({
                    listName: category.key,
                    handleAllCheckbox,
                    handleAllSelected,
                    handleAllIndeterminate,
                  })}
                  scroll={{ x: true }}
                />
              )}
            </Form.List>

            <Divider />
          </div>
        );
      })}
    </>
  );
}
